"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.defaultProps = exports.propTypes = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _constants = require("../constants");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _InputError = _interopRequireDefault(require("./InputError"));

var _InputLabel = _interopRequireDefault(require("./InputLabel"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAutosizeTextarea = _interopRequireDefault(require("react-autosize-textarea"));

var _TextInput = require("./TextInput");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var propTypes = {
  label: _propTypes["default"].string,
  labelStyle: _propTypes["default"].oneOf(_constants.TextLabelStyles),
  inputStyle: _propTypes["default"].oneOf(_constants.TextInputTypes),
  onChange: _propTypes["default"].func,
  error: _propTypes["default"].string
};
exports.propTypes = propTypes;
var defaultProps = {
  inputStyle: "achievement",
  labelStyle: "dark",
  error: "",
  value: ""
};
exports.defaultProps = defaultProps;

var TextareaAutosize__ = function TextareaAutosize__(_ref) {
  var inputStyle = _ref.inputStyle,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["inputStyle"]);
  return /*#__PURE__*/_react["default"].createElement(_reactAutosizeTextarea["default"], rest);
};

var TextareaAutosize = (0, _styledComponents["default"])(TextareaAutosize__).withConfig({
  displayName: "TextareaAutosize",
  componentId: "sc-1j9xz7h-0"
})(["", ";"], (0, _styledComponents.css)(["", ";"], _TextInput.inputStyles));

var TextareaInput = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(TextareaInput, _Component);

  var _super = _createSuper(TextareaInput);

  function TextareaInput() {
    (0, _classCallCheck2["default"])(this, TextareaInput);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(TextareaInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          required = _this$props.required,
          label = _this$props.label,
          labelStyle = _this$props.labelStyle,
          error = _this$props.error,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["required", "label", "labelStyle", "error"]);
      return /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], {
        required: required,
        label: label,
        labelStyle: labelStyle || rest.inputStyle
      }, error.length !== 0 && /*#__PURE__*/_react["default"].createElement(_InputError["default"], null, error), /*#__PURE__*/_react["default"].createElement(TextareaAutosize, rest));
    }
  }]);
  return TextareaInput;
}(_react.Component);

TextareaInput.propTypes = propTypes;
TextareaInput.defaultProps = defaultProps;
var _default = TextareaInput;
exports["default"] = _default;